import React from 'react';
import FormGroup from './FormGroup';

export interface FormInputNumberProps {
  name?: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string | number;
  register?: any;
  required?: boolean;
  error?: unknown;
  errorMessage?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  testId?: string;
}

const FormInputNumber = ({
  name,
  label,
  placeholder,
  defaultValue,
  register,
  required,
  error,
  errorMessage,
  onChange,
  className,
  autoFocus,
  disabled,
  testId,
}: FormInputNumberProps) => (
  <FormGroup
    label={label}
    error={Boolean(error)}
    errorMessage={errorMessage}
    required={required}
  >
    <input
      {...(name != null ? register(name, { required }) : {})}
      type="number"
      aria-label={label}
      name={name}
      placeholder={placeholder}
      className={`form-control ${className || ''}`}
      defaultValue={defaultValue}
      data-lpignore="true"
      autoComplete="off"
      onChange={onChange}
      autoFocus={autoFocus ?? false}
      disabled={disabled ?? false}
      data-cy={testId}
    />
  </FormGroup>
);
export default FormInputNumber;
